"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ua_parser_js_1 = require("ua-parser-js");
let parsedUserAgent;
function useUserAgent() {
    if (!parsedUserAgent) {
        const uaParser = new ua_parser_js_1.UAParser();
        parsedUserAgent = uaParser.getResult();
    }
    return parsedUserAgent;
}
exports.default = useUserAgent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlVXNlckFnZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9ob29rcy91c2VVc2VyQWdlbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQ0FBd0M7QUFFeEMsSUFBSSxlQUFlLENBQUM7QUFFcEIsU0FBd0IsWUFBWTtJQUNsQyxJQUFJLENBQUMsZUFBZSxFQUFFO1FBQ3BCLE1BQU0sUUFBUSxHQUFHLElBQUksdUJBQVEsRUFBRSxDQUFDO1FBQ2hDLGVBQWUsR0FBRyxRQUFRLENBQUMsU0FBUyxFQUFFLENBQUM7S0FDeEM7SUFDRCxPQUFPLGVBQWUsQ0FBQztBQUN6QixDQUFDO0FBTkQsK0JBTUMifQ==